import React, {Component} from 'react';
import Styles from './style.css';
import Header from "../../components/header/component";
import cx from "classnames";
import * as Icon from "react-feather";
import Footer from "../../components/footer/component";
import ContactForm from "../../components/contact-form/component";
import ProjectOdd from "../../components/project-odd/component";
import ProjectEqual from "../../components/project-equal/component";
import Chat from "../../components/chat/component";

class Partners extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount() {}

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div className={Styles.app}>
                <Chat/>
                <Header view={"/partners"} props={this.props}/>
                <div className={Styles.sectionTwo}>
                    <ProjectEqual
                        name={"Escrow Made Easy"}
                        title={"Escrow Made Easy"}
                        description={"Escrow Made Easy is an all-in-one platform designed for seamless initiation, transaction, exchange and deal."}
                        large={"40%"}
                        medium={"45%"}
                        small={"70%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1728054061/swedish%20tech%20mafia/EME_Logotype_vertical_RGB_white_white_tbyolj.png"}
                        website_link={"https://escrowmadeeasy.com"}
                        first_color={"#0D9E81"}
                        second_color={"#16D3AD"}
                    />
                    <ProjectOdd
                        name={"Domain Conveyancing"}
                        title={"Planned To Perfection"}
                        description={"Domain Conveyancing delivers efficient, seamless conveyancing through a dedicated legal team."}
                        large={"40%"}
                        medium={"45%"}
                        small={"70%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1776633981/swedish%20tech%20mafia/Domain_Logotype_Inv_xldbzt.svg"}
                        website_link={"https://domainconvey.com"}
                        first_color={"#C52F67"}
                        second_color={"#EA3B7C"}
                    />
                    <ProjectEqual
                        name={"ROISEC"}
                        title={"PROPERTY TECHNOLOGY ADVANCED"}
                        description={"ROISEC is a property technology innovation company, providing value added ways to transact properties and supportive technology."}
                        large={"50%"}
                        medium={"60%"}
                        small={"80%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1776630529/swedish%20tech%20mafia/ROISEC_Logotype_RGB_Inv_tnqwuk.svg"}
                        //website_link={"https://roisec.com"}
                        first_color={"#BEBE68"}
                        second_color={"#E8E6A0"}
                    />
                    <ProjectOdd
                        name={"Adtropi"}
                        title={"Better Than Marketing"}
                        description={"Adtropi is an online marketing powerhouse developing AI-driven omnichannel solutions for a new breed of digital marketers looking for performance at scale."}
                        large={"50%"}
                        medium={"50%"}
                        small={"70%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1660398523/swedish%20tech%20mafia/Adtropi_Logotype_RGB_White_pp9lhe.png"}
                        //website_link={"https://adtropi.com"}
                        first_color={"#F86A19"}
                        second_color={"#F89C00"}
                    />
                    <ProjectEqual
                        name={"adBooster"}
                        title={"adtech for bulk"}
                        description={"Adbooster is an adtech company serving high volume advertisers within real estate, hospitality, automotive and other verticals."}
                        large={"50%"}
                        medium={"60%"}
                        small={"80%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1660398523/swedish%20tech%20mafia/Adbooster_Logotype_RGB_White_f78m3r.png"}
                        website_link={"https://adbooster.ai"}
                        first_color={"#667EEA"}
                        second_color={"#66A6EA"}
                    />
                    <ProjectOdd
                        name={"ZAND DYNASTY"}
                        title={"reinterpreting fashion confidently"}
                        description={"By taking advantage of the vast digital and public presence of the colourful personality Nina Zandnia, Zand Dynasty aim to fuel the fashion community with confident innovation."}
                        large={"40%"}
                        medium={"50%"}
                        small={"70%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1776631446/swedish%20tech%20mafia/ZandDynasty_Logo_Shield_Inv_ea20v3.svg"}
                        //website_link={"https://zand-dynasty.com"}
                        first_color={"#000000"}
                        second_color={"#1E1E1E"}
                    />
                    {
                        <ProjectEqual
                            name={"PRIMEHIT"}
                            title={"Online Advertising Futurized"}
                            description={"Primehit strives to simplify and automate the way businesses advertise online, by bridging advantages of programmatic advertising with traditional know-how."}
                            large={"50%"}
                            medium={"50%"}
                            small={"70%"}
                            logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1776631791/swedish%20tech%20mafia/Primehit_Inv_o6xchx.svg"}
                            website_link={"https://primehit.com"}
                            first_color={"#00A4DF"}
                            second_color={"#7ACFF4"}
                        />
                    }
                    <ProjectOdd
                        name={"TRADEBRITE"}
                        title={"fintech for sme"}
                        description={"Tradebrite is a Fintech company designed to bring professional settlement direct to small medium enterprises."}
                        large={"40%"}
                        medium={"50%"}
                        small={"70%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1660398523/swedish%20tech%20mafia/Tradebrite_Logotype_RGB_White_g55icf.png"}
                        first_color={"#5CC2FD"}
                        second_color={"#9DEBFC"}
                    />
                </div>
                <ContactForm/>
                <Footer props={this.props}/>
            </div>
        );
    }
}

export default Partners;


// WEBPACK FOOTER //
// ./src/pages/partners/component.js